import angular from 'angular';
import { postPinBodyComponent } from './postPinBodyComponent';

angular.module('sh.postPinBody', ['sh.bindHtml']).component('shPostPinBody', postPinBodyComponent());
